import * as React from 'react';
import { pipe, constFalse } from 'fp-ts/lib/function';
import * as t from 'io-ts';
import * as E from 'fp-ts/Either';
import * as A from 'fp-ts/Array';

import { useStore } from '../../../contexts/StoreContext';

const DismissedPromptsRecord = t.array(t.string);
const PRE_MATCH_DISMISSED_PROMPTS_KEY = 'lkr_prmd';
const POST_MATCH_DISMISSED_PROMPTS_KEY = 'lkr_pomd';

type PromptType = 'pre' | 'post';

export const useDismissMatchPrompts = (
  matchId: string,
  promptType: PromptType,
) => {
  const store = useStore();
  const [inc, setInc] = React.useState(1);
  const key =
    promptType === 'pre'
      ? PRE_MATCH_DISMISSED_PROMPTS_KEY
      : POST_MATCH_DISMISSED_PROMPTS_KEY;

  const hasDismissedPrompts = React.useMemo(
    () =>
      pipe(
        store.get(key),
        DismissedPromptsRecord.decode,
        E.map((dismissedIds) => dismissedIds.includes(matchId)),
        E.getOrElse(constFalse),
      ),
    [inc, matchId, promptType],
  );

  const dismissPrompt = () =>
    pipe(
      store.get(key),
      DismissedPromptsRecord.decode,
      E.getOrElse((): string[] => []),
      A.prepend(matchId),
      (newDismissedIds) => store.set(key, newDismissedIds),
      () => setInc((i) => i + 1),
    );

  return [hasDismissedPrompts, dismissPrompt] as const;
};
